var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-wallets"},[_c('h3',{staticClass:"mb-3"},[_vm._v(" "+_vm._s(_vm.$t('Aggregating wallets'))+" ")]),_c('FinanceWalletsAggregation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }